import { setState } from '../storage';

const shouldSkipCache = (mutation) => {
  //SoNo: delete this output its only there, that var is not unused
  if(mutation.type in ['set_satus_msg_active','activateConfirmPopup','deactivateConfirmPopup']){
    return true;
  }
  //default case
  return false;
};

const plugin = (store) => {
  store.subscribe((mutation, state) => {
    if (!shouldSkipCache(mutation)) {
      setState(state).then(function(){
      }).catch(err => console.warn('failed to cache state', err));
    }
  });
};

export default plugin;